/**
 * Parses date string in various formats and returns timestamp in seconds
 * Supports formats: MM_YYYY, DD_MM_YYYY, DD_MM_YYYY_HH_MM
 */
export const parseModalDateString = (dateString: string): number | null => {
    if (!dateString || typeof dateString !== 'string') {
        return null
    }

    const parts = dateString.split('_')
    
    if (parts.length === 2) {
        // Format: MM_YYYY
        const [month, year] = parts.map((p: string) => parseInt(p, 10))
        const date = new Date(year, month - 1, 1) // month is 0-indexed in JS, set day to 1
        return Math.floor(date.getTime() / 1000) // return timestamp in seconds
    }
    
    if (parts.length === 3) {
        // Format: DD_MM_YYYY
        const [day, month, year] = parts.map((p: string) => parseInt(p, 10))
        const date = new Date(year, month - 1, day)
        return Math.floor(date.getTime() / 1000)
    }
    
    if (parts.length === 5) {
        // Format: DD_MM_YYYY_HH_MM
        const [day, month, year, hour, minute] = parts.map((p: string) => parseInt(p, 10))
        const date = new Date(year, month - 1, day, hour, minute)
        return Math.floor(date.getTime() / 1000)
    }
    
    return null
}

/**
 * Converts timestamp (in seconds or milliseconds) to DD_MM_YYYY string format
 */
export const formatModalDateString = (timestamp: number): string => {
    const date = timestamp > 10000000000 ? new Date(timestamp) : new Date(timestamp * 1000)
    
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    
    return `${day}_${month}_${year}`
}
